"use client";
import { ReactNode, useEffect } from 'react';
import Div100Vh from 'src/components/div100vh/Div100Vh';
import CloseSvg from 'src/components/svg/CloseSvg';
import styles from "./FullPageOverlay.module.css";

//#region [Props]
type FullPageOverlayProps = {
    children: ReactNode;
    onClose?: () => void;
    hideCloseButton?: boolean;
    closeOnClick?: boolean;
};
//#endregion

//#region [Component]
export default function FullPageOverlay({ children, onClose, hideCloseButton = false, closeOnClick = false }: FullPageOverlayProps) {
    useEffect(() => {
        document?.body?.classList?.add("noscroll");
        return () => {
            document?.body?.classList?.remove("noscroll");
        }
    }, []);
    return <Div100Vh className={styles.SFullPageOverlay} onClick={closeOnClick ? onClose : undefined}>
        <div className={styles.SOverlayContent}>{children}</div>
        {!hideCloseButton && <button className={styles.SCloseButton} onClick={onClose}><CloseSvg /></button>}
    </Div100Vh>;
}
//#endregion